export const groupNameNormalizer = (name) => {
    if (!name) return "";
    return name.replace(/^INTERNAL_/, "").replace("_", " ");
};

/**
 * Groups grid "Group Name" sort — match the column display.
 * Shared whole-class groups often share the same label (e.g. "1st Whole Class");
 * the teacher under the name is what distinguishes them, so include that before
 * falling back to last name.
 */
export const compareGroupNameColumn = (a, b, direction = "ascending") => {
    const dir = direction === "descending" ? -1 : 1;
    const byName = (a.groupName || "").localeCompare(b.groupName || "");
    if (byName !== 0) return byName * dir;
    const byTeacher = (a.groupHomeroomTeacher || "").localeCompare(b.groupHomeroomTeacher || "");
    if (byTeacher !== 0) return byTeacher * dir;
    return (a.lastName || "").localeCompare(b.lastName || "");
};
